import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { Form, Button, Input, Checkbox, Row } from 'antd';

import AuthShell from '../../components/auth-shell';
import shell from '../../components/auth-shell/index.module.css';
import SsoButtons from '../../components/sso-buttons';
import { OAuthProvider } from '../../../../fsm/auth';

interface Props {
  isLoading: boolean;
  onLogin: (email: string, password: string) => void;
  onOAuthLogin: (provider: OAuthProvider) => void;
}

const SignIn = ({ isLoading, onLogin, onOAuthLogin }: Props) => {
  const [form] = Form.useForm();

  const onFinish = useCallback(() => {
    onLogin(form.getFieldValue('email'), form.getFieldValue('password'));
  }, [onLogin, form]);

  return (
    <AuthShell title="Sign in">
      <Form
        form={form}
        style={{ width: '100%' }}
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please input your email' },
            { type: 'email' },
          ]}
        >
          <Input placeholder="you@company.com" size="large" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Please input your password!' },
            {
              min: 8,
              message: 'Password must be at least 8 characters long!',
            },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/,
              message:
                'Password must include uppercase, lowercase, number, and special character!',
            },
          ]}
          hasFeedback
        >
          <Input.Password placeholder="••••••••" size="large" />
        </Form.Item>
        <Form.Item>
          <Row justify="space-between" align="middle">
            <Checkbox>Remember me</Checkbox>
            <Link to="/auth/reset-password" className={shell.link}>
              Forgot password?
            </Link>
          </Row>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="large"
            block
            htmlType="submit"
            loading={isLoading}
            className={shell.submitBtn}
          >
            Sign in
          </Button>
        </Form.Item>
      </Form>
      <SsoButtons disabled={isLoading} onSelect={onOAuthLogin} />
    </AuthShell>
  );
};

export default memo(SignIn);
